
define("json!rebrush/handles/default.json", function(){ return {
	"default": [
		"rebrush/components/plugin/usercentrics",
		"shoptheme/components/layout/default",
		"rebrush/components/layout/page/switch/storeview",
	  	"shoptheme/components/layout/page/sidebar-related",
		"shoptheme/components/layout/lazyload",
		"shoptheme/components/layout/messages",
		"rebrush/components/layout/navigation",
		"shoptheme/components/layout/trigger",
		"rebrush/components/layout/search",
	  	"shoptheme/components/layout/story",
		"shoptheme/components/layout/equal-heights",
		"shoptheme/components/ui/accordion",
		"shoptheme/components/ui/tabs",
		"shoptheme/components/ui/selects",
		"rebrush/components/ui/selects/native",
		"rebrush/components/ui/tooltips",
	  	"shoptheme/components/ui/affix",
		"shoptheme/components/ui/affix-generic",
		"shoptheme/components/ui/toggle-visibility",
		"shoptheme/components/ui/scrollspy",
	  	"shoptheme/components/ui/scrolltop",
		"rebrush/components/ui/generated-menu",
		"shoptheme/components/ui/sections",
		"rebrush/components/cart/ajax",
		"rebrush/components/cart/etracker",
		"shoptheme/components/product/wishlist",
		"rebrush/components/cartware/slider",
		"shoptheme/components/cartware/video",
		"shoptheme/components/customer/terms-of-use-agreement",
		"rebrush/components/compare/compare",
		"shoptheme/components/plugin/universal-analytics",
		"shoptheme/components/blocks/fce/elements/usps",
	  	"shoptheme/components/blocks/fce/elements/image-map",
	    "rebrush/components/blocks/hero-slider",
		"shoptheme/components/blocks/fce/elements/videoteaser",
	  	"shoptheme/components/blocks/fce/newsletter-subscribe-landingpage",
	  	"shoptheme/components/blocks/csp/detail/firmware-accordion",
		"shoptheme/components/blocks/captcha",
		"shoptheme/components/blocks/privacy/opt",
	  	"shoptheme/components/widgets/band",
		"shoptheme/components/tracking",
		"shoptheme/components/contentbridge/cms-search-results",
		"rebrush/components/blocks/raster-grid",
		"rebrush/components/blocks/raster-grid/tiles/image",
		"rebrush/components/blocks/raster-grid/tiles/video",
		"rebrush/components/layout/newsletter-subscribe",
		"cartware_checkout/components/agreements",
		"rebrush/components/blocks/cliplister/3dgallery",
		"rebrush/components/blocks/catalogsearch/autocomplete/recommendations",
		"rebrush/components/captcha/friendly-captcha"
	],

	"default_shop": [
		"rebrush/components/blocks/varnish/esi"
	],

	"gigaset_theme_home_index": [
		"shoptheme/components/layout/home"
	],

	"catalog_product_view": [
		"rebrush/components/product/view",
		"rebrush/components/product/view/media",
		"rebrush/components/product/view/specifications",
		"rebrush/components/product/view/description",
		"rebrush/components/product/view/review",
		"rebrush/components/product/view/related-link-in-description",
		"rebrush/components/product/view/addtocart/related",
		"rebrush/components/product/options",
		"rebrush/components/product/options/engraving",
		"rebrush/components/product/options/protection",
		"shoptheme/components/review/form",
		"rebrush/components/review/list",
		"shoptheme/components/product/view/store-ship",
		"shoptheme/components/plugin/multiline-placeholder",
		"rebrush/components/ui/sections",
		"rebrush/components/csp/product/download/item",
		"rebrush/components/category/layered",
		"rebrush/components/category/layered/filter",
		"rebrush/components/category/layered/slider",
		"rebrush/components/category/tree",
		"shoptheme/components/ui/sidebar",
        "rebrush/components/plugin/touch-controller",
		"rebrush/components/product/view/configurable-options-help",
		"rebrush/components/product/options/group",
		"rebrush/components/gigaset_customprint/legal",
		"rebrush/components/product/view/tracking"
	],

	"PRODUCT_TYPE_configurable": [
		"cartware/components/magento/product/type/configurable",
		"rebrush/components/product/type/configurable",
        "rebrush/components/product/type/configurable/addtocartbutton"
	],

	"catalog_category_layered": [
		"rebrush/components/category/layered",
		"rebrush/components/category/layered/filter",
		"rebrush/components/category/layered/slider",
	  	"rebrush/components/category/tree",
		"shoptheme/components/ui/sidebar",
        "rebrush/components/plugin/touch-controller"
	],

	"newsletter_manage_index": [
		"shoptheme/components/customer/newsletter"
	],

	"customer_account_create": [
		"shoptheme/components/customer/account/create"
	],

	"customer_account_edit": [
		"shoptheme/components/customer/account/edit"
	],

	"gigaset_theme_policy_index": [
		"shoptheme/components/customer/account/policy"
	],

	"gigaset_contentbridge_cms_page": [
		"rebrush/components/contentbridge/tabs",
		"shoptheme/components/contentbridge/accordeon"
	],

	"gigaset_theme_category_style_elements_1": [
		"shoptheme/components/blocks/elements/product/item/pane"
	],

	"gigaset_csp_support_detail_videotutorials": [
		"shoptheme/components/blocks/fce/elements/videotutorials"
	],

	"gigaset_csp_support_detail_downloads": [
		"rebrush/components/csp/product/download/item"
	],

	"gigaset_csp_support_downloads": [
		"rebrush/components/csp/product/download/item"
	],

	"checkout_onepage_index": [
		"shoptheme/components/cartware/checkout",
		"rebrush/components/checkout/advises",
		"rebrush/components/checkout/password/onpage-validator",
		"rebrush/components/checkout/closing-loop",
		"rebrush/components/checkout/address/qaddress",
		"rebrush/components/checkout/reepay/checkout"
	],

	"gigaset_contentbridge_cms_page_col2-layout-article": [
		"rebrush/components/ui/anchor-navigation"
	],

	"gigaset_block_anchor_navigation": [
		"rebrush/components/ui/anchor-navigation"
	],

	"gigaset_hr_list": [
		"shoptheme/components/ui/datatables"
	],

  	"gigaset_hr_detail": [
		"shoptheme/components/ui/maps"
	],

	"b2e_agreements_popup": [
		"shoptheme/components/customer/b2e/popup"
	],

	"payone_core_pexpress_review": [
		"shoptheme/components/paypal/express/review"
	],
	"image_comparer": [
		"rebrush/components/blocks/image-comparer"
	],

	"lp_router_video": [
		"rebrush/components/blocks/landingpages/router/video"
	],

	"lp_router_app": [
		"rebrush/components/blocks/landingpages/router/app"
	],

	"gigaset_wheretobuy_product_view": [
		"rebrush/components/product/view/wheretobuy"
	],

	"catalog_product_customoption_print": [
		"rebrush/components/gigaset_customprint/view"
	],

	"checkout_cart_index": [
		"rebrush/components/blocks/discount-code",
		"rebrush/components/checkout/closing-loop"
	],

	"cartware_cart_popup_open": [
		"rebrush/components/product/view/description",
		"rebrush/components/product/view/addtocart/related"
	],

	"gigaset_tradein_index_index": [
		"rebrush/components/tradein/tradein"
	],

	"customer_referral_dashboard_index": [
		"rebrush/components/referral/progressbar"
	],

	"reepay_standard_redirect": [
		"rebrush/components/checkout/reepay/checkout"
	],

	"reepay_standard_success": [
		"rebrush/components/checkout/reepay/checkout"
	],

	"checkout_multishipping_shipping": [
		"rebrush/components/checkout/reepay/checkout"
	],

	"onepagecheckout_index_index": [
		"rebrush/components/checkout/reepay/checkout"
	],

	"opc_index_index": [
		"rebrush/components/checkout/reepay/checkout"
	],

	"onestepcheckout_index_index": [
		"rebrush/components/checkout/reepay/checkout"
	],

	"gigaset_shipping_return_index": [
		"rebrush/components/blocks/gigaset/shipping/sales/order/shipment/return"
	]
}
;});

